import { Timeframe } from "@/lib/enums/timeframe.enum";

export type PairAvailability = Record<string, Record<string, Timeframe[]>>;

export interface PairAvailabilityEntry {
  pair: string;
  exchange: string;
  timeframe: Timeframe;
  active?: boolean;
}

export interface TickerWithPairs {
  symbol: string;
  pairs?: PairAvailabilityEntry[];
}

const TIMEFRAME_ORDER = Object.values(Timeframe);
const TIMEFRAME_SET = new Set(TIMEFRAME_ORDER);

export const isTimeframe = (value: unknown): value is Timeframe =>
  typeof value === "string" && TIMEFRAME_SET.has(value as Timeframe);

export const sortTimeframes = (values: Timeframe[]): Timeframe[] => {
  return [...new Set(values)].sort(
    (a, b) => TIMEFRAME_ORDER.indexOf(a) - TIMEFRAME_ORDER.indexOf(b)
  );
};

export const buildPairAvailability = (
  tickers: TickerWithPairs[]
): PairAvailability => {
  const map: PairAvailability = {};

  tickers.forEach((ticker) => {
    (ticker.pairs || []).forEach((pair) => {
      if (pair.active === false) return;
      if (!pair.pair || !pair.exchange || !pair.timeframe) return;

      if (!map[pair.pair]) {
        map[pair.pair] = {};
      }

      const existing = map[pair.pair][pair.exchange] || [];
      map[pair.pair][pair.exchange] = sortTimeframes([
        ...existing,
        pair.timeframe,
      ]);
    });
  });

  return map;
};

